import React from 'react';
import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';

export default function AuthenticateMfaCode(props) {
  const [code, setCode] = React.useState('');
  const [error, setError] = React.useState();

  const submit = () => {
    setError(undefined);
    props.setLoading(true);
    props.signInFunc(code, (err) => {
      props.setLoading(false);
      setError(err);
    });
  };

  return (
    <div className='login-input-field mfa-enroll'>
      <h2 style={{ fontSize: '20px', borderBottom: '1px solid' }}>
        {props.context.t('multifactor_authentication')}
      </h2>

      {error && (
        <Alert className='mfa-error' severity='error'>
          {props.context.t('invalid_code')}
        </Alert>
      )}

      <p>{props.context.t('enter_an_mfa_code_to_complete_signin')}</p>
      <div className='mfa-field'>
        <label htmlFor='input-mfa-code'>{props.context.t('mfa_code')}</label>
        <input
          id='input-mfa-code'
          className='mfa-code-input'
          type='text'
          inputMode='numeric'
          autoComplete='one-time-code'
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              submit();
            }
          }}
        />
      </div>
      <div className='form-group form-actions'>
        <div className='col-xs-6 col-xs-offset-3 login-field'>
          <button
            className='login-submit btn btn-success btn-block'
            onClick={submit}
          >
            {props.context.t('submit')}
          </button>
        </div>
      </div>
      <div className='mfa-links'>
        <a href='#' onClick={() => props.backTo('signIn')}>
          {props.context.t('cancel')}
        </a>
      </div>
    </div>
  );
}

AuthenticateMfaCode.propTypes = {
  backTo: PropTypes.func.isRequired,
  context: PropTypes.object.isRequired,
  setLoading: PropTypes.func.isRequired,
  signInFunc: PropTypes.func.isRequired,
};
